<rma-layout-container [noContainer]="true">
  @for (notification of (notifications$ | async); track notification.id) {
    <ibp-bug-notification-card [notification]="notification"></ibp-bug-notification-card>
  }
</rma-layout-container>
